import { clsx } from "clsx";

import { type Category } from "~/api/products/types";

type CategoryBreadcrumbsProps = {
  categories: Category[];
  activeCategoryId: Category["id"] | null;
  onCategoryChange: (categoryId: Category["id"]) => void;
};

export const CategoryBreadcrumbs = ({
  categories,
  activeCategoryId,
  onCategoryChange
}: CategoryBreadcrumbsProps) => {
  return (
    <div className="flex w-full flex-wrap gap-3 px-8 py-4">
      {categories.map((category, index) => (
        <CategoryBadge
          key={category.id}
          category={category}
          onClick={onCategoryChange}
          isActive={
            category.id === activeCategoryId ||
            (index === 0 && activeCategoryId === null)
          }
        />
      ))}
    </div>
  );
};

type CategoryBadgeProps = {
  category: Category;
  onClick: (categoryId: Category["id"]) => void;
  isActive: boolean;
};

const CategoryBadge = ({ category, onClick, isActive }: CategoryBadgeProps) => {
  return (
    <button
      type="button"
      className={clsx("text-nowrap rounded-full text-2xl focus:outline-none", {
        "bg-kiosk-actions-sheet-primary-background font-bold text-kiosk-actions-sheet-primary-text px-6 py-4":
          isActive,
        "bg-kiosk-background-secondary font-normal text-kiosk-text-primary px-7 py-4":
          !isActive
      })}
      onClick={() => {
        onClick(category.id);
      }}
    >
      <span>{category.name}</span>
    </button>
  );
};
